import { iconMap } from "./iconMap";

export const USER_TYPES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  CLIENT_ADMIN: "CLIENT_ADMIN",
  SITE_ADMIN: "SITE_ADMIN",
  MANUFACTURER: "MANUFACTURER",
  ALERT_HANDLER: "ALERT_HANDLER",
  DISTRIBUTOR_ADMIN: "DISTRIBUTOR_ADMIN",
  INSTALLER_ADMIN: "INSTALLER_ADMIN",
  SHOPPER: "SHOPPER",
  STORE_BOUNCER: "STORE_BOUNCER",
  STORE_SECURITY: "STORE_SECURITY",
};

export const permissionsMap = {
  ALERT_HANDLER: {
    allowAddUsersType: [],
    i18nKey: "g.ALERT_HANDLER",
    defaultRoute: "/alert",
    getSensorStatuses: false,
    sideMenu: [
      {
        i18nKey: "menu.alert",
        icon: iconMap.priorityHighIcon,
        route: "alert?sev=CRITICAL",
      },
      {
        i18nKey: "menu.criticalAlerts",
        icon: iconMap.errorOutlineIcon,
        route: "alerts?sev=CRITICAL&no_filter=1",
        routeColor: "red",
      },
      {
        i18nKey: "menu.alertInfos",
        icon: iconMap.contactSupportIcon,
        route: "alerts",
      },
      {
        i18nKey: "menu.groundTruth",
        icon: iconMap.fingerprintIcon,
        route: "alerts?groundTruth=1",
      },
    ],
  },
  CLIENT_ADMIN: {
    allowAddUsersType: [USER_TYPES.CLIENT_ADMIN, USER_TYPES.SITE_ADMIN],
    i18nKey: "g.CLIENT_ADMIN",
    defaultRoute: "/products",
    getSensorStatuses: false,
    productEdit: {
      allow: "part",
      parts: ["price", "save"],
    },
    productActiveController: true,
    sideMenu: [
      {
        i18nKey: "menu.users",
        icon: iconMap.user,
        route: "users",
      },
      {
        i18nKey: "menu.products",
        icon: iconMap.product,
        route: "products",
      },
    ],
    userAdd: {
      getClients: false,
      getSites: true,
    },
  },
  SITE_ADMIN: {
    allowAddUsersType: [
      USER_TYPES.SITE_ADMIN,
      USER_TYPES.STORE_BOUNCER,
      USER_TYPES.STORE_SECURITY,
    ],
    i18nKey: "g.SITE_ADMIN",
    defaultRoute: "/im-main",
    getSensorStatuses: true,
    productActiveController: true,
    productEdit: {
      allow: "part",
      parts: ["price", "save"],
    },
    sideMenu: [
      {
        i18nKey: "menu.dashboard",
        icon: iconMap.dashboardIcon,
        route: "im-main",
      },
      {
        i18nKey: "menu.storeShelves",
        icon: iconMap.sensor,
        route: "store-shelves",
      },
      {
        i18nKey: "menu.inventory",
        icon: iconMap.inventoryIcon,
        route: "inventory-management",
      },
      {
        i18nKey: "menu.users",
        icon: iconMap.user,
        route: "users",
      },
      {
        i18nKey: "menu.alertInfos",
        icon: iconMap.contactSupportIcon,
        route: "alerts",
        routeColor: "red",
      },
      {
        i18nKey: "menu.sigBusket",
        icon: iconMap.functionsIcon,
        route: "sig-busket",
      },
      {
        i18nKey: "menu.products",
        icon: iconMap.product,
        route: "products",
      },
      {
        i18nKey: "Add Planogram",
        icon: iconMap.palnogramIcon,
        route: "planogram",
      },
      {
        i18nKey: "show Fields",
        icon: iconMap.viewComfyOutlinedIcon,
        route: "tv/fields",
      },
      
    ],
  },
  SUPER_ADMIN: {
    allowAddUsersType: [
      USER_TYPES.SUPER_ADMIN,
      USER_TYPES.MANUFACTURER,
      USER_TYPES.ALERT_HANDLER,
    ],
    i18nKey: "g.SUPER_ADMIN",
    defaultRoute: "/shoppers",
    getSensorStatuses: true,
    productListActions: {
      allow: true,
    },
    productEdit: {
      allow: "all",
    },
    sideMenu: [
      {
        i18nKey: "menu.users",
        icon: iconMap.user,
        route: "users",
      },
      {
        i18nKey: "menu.shoppers",
        icon: iconMap.shopper,
        route: "shoppers",
      },
      {
        i18nKey: "menu.sensors",
        icon: iconMap.sensor,
        route: "sensors",
      },
      {
        i18nKey: "menu.distributors",
        icon: iconMap.distributor,
        route: "distributors",
      },
      {
        i18nKey: "menu.products",
        icon: iconMap.product,
        route: "products",
      },
      {
        i18nKey: "menu.ai-report",
        icon: iconMap.graphIcon,
        route: "ai-report",
      },
      {
        i18nKey: "Add Planogram",
        icon: iconMap.palnogramIcon,
        route: "planogram",
      },
      {
        i18nKey: "show Fields",
        icon: iconMap.viewComfyOutlinedIcon,
        route: "tv/fields",
      },
      
    ],
  },
  DISTRIBUTOR_ADMIN: {
    allowAddUsersType: [USER_TYPES.DISTRIBUTOR_ADMIN],
    i18nKey: "g.DISTRIBUTOR_ADMIN",
    defaultRoute: "/installers",
    getSensorStatuses: true,
    sideMenu: [
      {
        i18nKey: "menu.users",
        icon: iconMap.user,
        route: "users",
      },
      {
        i18nKey: "menu.sensors",
        icon: iconMap.sensor,
        route: "sensors",
      },
      {
        i18nKey: "menu.edges",
        icon: iconMap.edge,
        route: "edges",
      },
      {
        i18nKey: "menu.installers",
        icon: iconMap.installer,
        route: "installers",
      },
    ],
  },
  INSTALLER_ADMIN: {
    allowAddUsersType: [USER_TYPES.INSTALLER_ADMIN, USER_TYPES.CLIENT_ADMIN],
    i18nKey: "g.INSTALLER_ADMIN",
    getSensorStatuses: true,
    defaultRoute: "/stores",
    userAdd: {
      getClients: true,
      getSites: false,
    },
    sideMenu: [
      {
        i18nKey: "menu.stores",
        icon: iconMap.store,
        route: "stores",
      },
      {
        i18nKey: "menu.users",
        icon: iconMap.user,
        route: "users",
      },
      {
        i18nKey: "menu.sensors",
        icon: iconMap.sensor,
        route: "sensors",
      },
      {
        i18nKey: "menu.edges",
        icon: iconMap.edge,
        route: "edges",
      },

      {
        i18nKey: "Add Planogram",
        icon: iconMap.palnogramIcon,
        route: "planogram",
      },

      {
        i18nKey: "show Fields",
        icon: iconMap.viewComfyOutlinedIcon,
        route: "tv/fields?client=66f11443c8adb8d1ed21ab62&store=66f11d80c8adb8d1ed21ae0e&edge=670b909553bffca72d369d01",
      },
      {
        i18nKey: "show floor",
        icon: iconMap.brickWall,
        
        route: "floors",
      },
      {
        i18nKey: "anti thieves",
        icon: iconMap.transferWithinAStationIcon,
        
        route: "tv/anti-thieves",
      },

      {
        i18nKey: "show logs",
        icon: iconMap.pestControlIcon,
        
        route: "logs",
      },
    ],
  },
  MANUFACTURER: {
    allowAddUsersType: [USER_TYPES.MANUFACTURER],
    i18nKey: "g.MANUFACTURER",
    getSensorStatuses: true,
    defaultRoute: "/sensors",
    sideMenu: [
      {
        i18nKey: "menu.sensors",
        icon: iconMap.sensor,
        route: "sensors",
      },
      {
        i18nKey: "menu.firmware",
        icon: iconMap.confirmationNumberIcon,
        route: "firmware",
      },
    ],
  },
  SHOPPER: {
    allowAddUsersType: [USER_TYPES.SHOPPER],
    i18nKey: "g.shopper",
    defaultRoute: "/cart",
    getSensorStatuses: false,
    sideMenu: [
      {
        i18nKey: "menu.cart",
        icon: iconMap.shoppingCartIcon,
        route: "cart",
      },
      {
        i18nKey: "menu.profile",
        icon: iconMap.accountCircleIcon,
        route: "profile",
      },
    ],
  },
};
